import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Part from './Part';
import type { AogPartDetails } from '../../Models/Orderpart';
import { getAogParts } from '../../services/otsEventService';
import {useAuthentication } from "meportal/AuthenticationProvider";
import './Part.scss';

const ViewParts: React.FC<{ refreshKey: number }> = ({ refreshKey }) => {
   const { userData, getLatestAccessToken } = useAuthentication();
   const [parts, setParts] = useState<AogPartDetails[]>([]);
   const eventId = useSelector((state: any) => state.otsAircraft?.otsAircraft?.id);

  useEffect(() => {
    const fetchParts = async () => {
      try {
        const token = await getLatestAccessToken();
        const userWithToken = { ...userData, access_token: token };

        if (eventId) {
          const response = await getAogParts(userWithToken, eventId);
          if (response && response.Parts) {    
            const serviceParts = response.Parts.map((part: AogPartDetails) => ({
                PartNumber: part.PartNumber,
                Description: part.PartName,
                Quantity: part.Quantity,
                Status: part.Status,
                StatusText: part.StatusText,
                CreatedBy: part.CreatedBy,
                Flt: response.Flt,
                PartComment: part.PartComment,
                IPC: part.IPC
                }));
            setParts([...serviceParts]);
          }
        }
      } catch (error) {
        console.error('Error fetching parts:', error);
      }
    };

    fetchParts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, getLatestAccessToken, eventId, refreshKey]);

  return (
    <div className="view-parts-container">

      {parts.length === 0 && <span className="ordered-item-list-empty">No parts requested add this time. Fill form below to request new parts</span>}

      {parts.length > 0 && <div className="parts-list">
        {parts.map((part, index) => (
          <Part
            key={`${part.PartNumber}-${index}`}
            partData={part}
            isExpandable={true}
            defaultExpanded={false}
          />
        ))}
      </div>}
    </div> 
  );
};

export default ViewParts;
